// Minimal per-route SEO for the client-rendered pages: swap the head tags
// crawlers read (title is handled by each page) and restore the site
// defaults on unmount.

const SITE_URL = 'https://adityapatel.net';

export const DEFAULT_SEO = {
    description: 'Aditya Patel builds across mobile products, cloud infrastructure, distributed systems, and AI.',
    keywords: 'Aditya Patel, software engineer, portfolio',
    canonical: SITE_URL,
    ogTitle: 'Aditya Patel',
    ogDescription: 'Selected experience and projects across mobile, cloud, distributed systems, and AI.',
};

export const PAGE_SEO = {
    'distributed-systems': {
        description: 'Interactive DSLabs coursework (Purdue CS 505): exactly-once RPC, primary/backup replication, Multi-Paxos consensus, and sharded transactions — guided traces plus a hands-on deterministic simulator.',
        keywords: 'paxos, multi-paxos, dslabs, distributed systems, purdue cs 505, cs 50500, primary backup replication, view service, exactly-once rpc, sharding, two-phase commit, consensus, replicated state machine',
        canonical: `${SITE_URL}/coursework/distributed-systems`,
        ogTitle: 'Distributed Systems Labs · Aditya Patel',
        ogDescription: 'Paxos, replication, sharding, and transactions from Purdue CS 505 DSLabs — trace the protocols, then drive them yourself.',
    },
    'unix-shell': {
        description: 'Purdue CS 252 coursework: a Unix shell in C++ with a Lex/Yacc parser, fork/exec pipelines, I/O redirection, jobs, expansion, and control flow.',
        keywords: 'unix shell, cs 252, purdue cs 252, lex, yacc, shell parser, fork exec, io redirection, job control',
        canonical: `${SITE_URL}/coursework/unix-shell`,
        ogTitle: 'Unix Shell · Aditya Patel',
        ogDescription: 'A Unix shell from parsing to process control — Purdue CS 252 coursework in C++.',
    },
    'operating-systems': {
        description: 'Purdue CS 354 coursework: five labs inside Xinu — process creation, send/receive IPC, per-process state, kernel tables, and system calls in C.',
        keywords: 'xinu, operating systems, cs 354, purdue cs 354, process creation, inter-process communication, system calls, kernel',
        canonical: `${SITE_URL}/coursework/operating-systems`,
        ogTitle: 'Xinu Operating Systems · Aditya Patel',
        ogDescription: 'Working inside an operating system — Purdue CS 354 coursework in the Xinu kernel.',
    },
    'ai-search-agents': {
        description: 'Purdue CS 471 coursework: DFS, BFS, uniform-cost, and A* search plus minimax, alpha-beta pruning, and expectimax game agents in Python.',
        keywords: 'ai search, a star, minimax, alpha beta pruning, expectimax, cs 471, purdue cs 471, berkeley ai, game agents',
        canonical: `${SITE_URL}/coursework/ai-search-agents`,
        ogTitle: 'AI Search Agents · Aditya Patel',
        ogDescription: 'Search and game-playing agents — Purdue CS 471 coursework in Python.',
    },
};

function upsertMeta(attr, key, content) {
    let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
}

function upsertCanonical(href) {
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
    }
    link.setAttribute('href', href);
}

export function applyPageSeo(page) {
    const seo = PAGE_SEO[page] || DEFAULT_SEO;
    upsertMeta('name', 'description', seo.description);
    upsertMeta('name', 'keywords', seo.keywords);
    upsertMeta('property', 'og:title', seo.ogTitle);
    upsertMeta('property', 'og:description', seo.ogDescription);
    upsertMeta('property', 'og:url', seo.canonical);
    upsertCanonical(seo.canonical);
}

export function resetSeo() {
    upsertMeta('name', 'description', DEFAULT_SEO.description);
    upsertMeta('name', 'keywords', DEFAULT_SEO.keywords);
    upsertMeta('property', 'og:title', DEFAULT_SEO.ogTitle);
    upsertMeta('property', 'og:description', DEFAULT_SEO.ogDescription);
    upsertMeta('property', 'og:url', DEFAULT_SEO.canonical);
    upsertCanonical(DEFAULT_SEO.canonical);
}
